import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IActivity } from '../../../dto-map/i-activity';
import { ActorCardCollectionService } from './actor-card-collection.service';

@Component({
  selector: 'ss-actor-card-collection',
  templateUrl: './actor-card-collection.component.html',
  styleUrls: ['./actor-card-collection.component.scss'],
  host: {
    class: 'flex-column gap-small padding-small'
  },
  providers: [
    ActorCardCollectionService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActorCardCollectionComponent implements OnInit {


  readonly activitiesGroupedObs = this._actorCardCollectionService.activitiesGroupedObs;
  readonly hideGroupSubject = this._actorCardCollectionService.hideGroupSubject;


  constructor(
    private _actorCardCollectionService: ActorCardCollectionService,
  ) { }

  ngOnInit(): void {
  }

  getActivities([, activities]: readonly [string, IActivity[]]) {
    return activities;
  }

  getOrderIndex([orderIndex]: readonly [string, IActivity[]]) {
    return Number(orderIndex);
  }

  trackById(idx: number, activity: IActivity) {
    return activity.id
  }


}
